import * as yup from 'yup';

export const schema = yup.object({
    name: yup.string().nullable().required(),
});

export type CostCenterSchema = yup.InferType<typeof schema>;
